<template>
  <div :id="id" class="echarts" />
</template>

<script>
export default {
  name: '',
  components: {

  },
  mixins: [

  ],
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      id: `echarts${Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36)}`,
      myEchart: null
    }
  },
  computed: {

  },
  watch: {
    data: {
      handler: function() {
        this.dram()
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {
    this.dram()
  },
  methods: {
    dram() {
      var _this = this
      var echartData = [
        {
          value: _this.data.xuNum,
          precent: ((_this.data.xuNum / _this.data.allNum) * 100).toFixed(2),
          name: '续费数量',
          itemStyle: {
            normal: { // 颜色渐变
              color: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(83, 229, 55, 1)' },
                  { offset: 1, color: 'rgba(33, 181, 33, 1)' }
                ]
              )
            }
          }
        } ,
        {
          value: _this.data.actNum,
          precent: ((_this.data.actNum / _this.data.allNum) * 100).toFixed(2),
          name: '激活数量',
          itemStyle: {
            normal: { // 颜色渐变
              color: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(24, 111, 255, 1)' },
                  { offset: 1, color: 'rgba(82, 241, 255, 1)' }
                ]
              )
            }
          }
        },
        {
          value: _this.data.tuiNum,
          precent: ((_this.data.tuiNum / _this.data.allNum) * 100).toFixed(2),
          name: '退款数量',
          itemStyle: {
            normal: { // 颜色渐变
              color: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(228, 173, 25, 1)' },
                  { offset: 1, color: 'rgba(237, 222, 49, 1)' }
                ]
              )
            }
          }
        }
      ]
      var option = {
        title: {
          text:  _this.data.allNum,
          subtext: ' 总数',
          textStyle: {
            color: '#fff',
            fontSize: 20,
            fontWeight: 600,
            textAlign: 'center'
          },
          subtextStyle: {
            fontSize: 14,
            color: '#A6B3C6',
            textAlign: 'center'
          },
          left:'16%',
          y:'40%'
        },
        legend: {
          orient: 'vertical',
          top: 'center',
          right: '2%',
          itemWidth: 15, // 设置图例图形的宽
          itemHeight: 15, // 设置图例图形的高
          itemGap: 30,
          textStyle: {
            color: '#fff',
            fontFamily: '微软雅黑',
            fontSize: 12,
            rich: {
              name: {
                width: 60,
                color: '#BABBBB',
                fontSize: 14,
                padding: [0, 0, 0, 0]
              },
              value: {
                width: 60,
                color: '#FFFFFF',
                fontSize: 12,
                padding: [0, 0, 0, 10]
              },
              rate: {
                color: 'rgba(93, 134, 187, 1)',
                fontSize: 12,
                padding: [0, 0, 0, 0]
              }
            }
          },
          formatter: (name) => {
            if (echartData.length) {
              const item = echartData.filter((item) => item.name === name)[0]
              return `{name|${name}}{value| ${item.value + '个'}} {rate| ${item.precent}%}`
            }
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            itemStyle: {
              borderWidth: 5,
              borderColor: '#03294a'
            },
            center: ['22%', '50%'],
            radius: ['60%', '70%'],
            hoverAnimation: false,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: echartData
          },
          {
            // name: "白色圈刻度",
            type: 'gauge',
            center: ['22%', '50%'],
            radius: '70%',
            startAngle: 225, // 刻度起始
            endAngle: -134.8, // 刻度结束
            z: 4,
            axisTick: {
              show: true,
              lineStyle: {
                width: 2,
                color: 'rgba(75, 102, 159, 1)'
              }
            },
            splitLine: {
              show: false

            },
            axisLabel: {
              color: 'rgba(255,255,255,0)',
              fontSize: 12
            }, // 刻度节点文字颜色
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                opacity: 0
              }
            },
            detail: {
              show: false
            },
            data: [{
              value: 0,
              name: ''
            }]
          }
        ]
      }
      this.myEchart = this.$echarts.init(document.getElementById(this.id))
      this.myEchart.setOption(option, true)
      window.addEventListener('resize', () => {
        this.myEchart.resize()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .echarts{
    width: 100%;
    height: 100%;
  }
</style>
